import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-nav-text-snapshot',
  templateUrl: './header-nav-text-snapshot.component.html',
  styleUrls: ['./header-nav-text-snapshot.component.css']
})
export class HeaderNavTextSnapshotComponent {
  @Input() isAddClientDetails: boolean = false;
}
